import React from "react";
import { AutocompleteProps } from "@mui/material/Autocomplete";
import { TextField, TextFieldProps } from "../TextField";
import { Autocomplete } from "./styles";

export type ComboBoxProps<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
> = Omit<
  AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
  "renderInput"
> & {
  textFieldProps?: TextFieldProps;
};

export function ComboBox<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>({
  textFieldProps,
  ...props
}: ComboBoxProps<T, Multiple, DisableClearable, FreeSolo>) {
  return (
    <Autocomplete
      {...(props as any)}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          InputProps={{
            ...params.InputProps,
            ...(textFieldProps ?? {})?.InputProps,
          }}
          inputProps={{
            ...(textFieldProps ?? {})?.inputProps,
            ...params.inputProps,
          }}
        />
      )}
    />
  );
}
